import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { TranscriptGetOneResponseDto } from '../../../../../../../../../../../backend/src/case/transcription/dto/transcript-get-one.response.dto';
import { capitalizeFirstLetter } from '@/helpers/filterNames';
import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/new/components/shadcn/dialog';
import { SubTitle } from '@/new/components/subtitle';

export function TranscriptHeader({
  transcript,
  allTranscriptsLink,
}: {
  transcript: TranscriptGetOneResponseDto;
  allTranscriptsLink: string;
}) {
  const { i18n, t } = useTranslation();
  return (
    <div className="flex items-center gap-4">
      <Link to={allTranscriptsLink} className="flex items-center">
        <Icon className="lucide--arrow-left text-gray-500 duration-150 hover:text-gray-900" />
      </Link>

      <SubTitle text={transcript.name} />

      <Dialog>
        <DialogTrigger asChild>
          <Button size="icon" className="p-1">
            <Icon className="lucide--info" />
          </Button>
        </DialogTrigger>

        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              <Icon className="lucide--info -mb-0.25 text-teal-500" />
              <span>Transcript Information</span>
            </DialogTitle>
          </DialogHeader>
          <div className="flex flex-col gap-3">
            <div>
              <p className="mb-2 font-medium text-gray-700">{capitalizeFirstLetter(t('witness'))}:</p>
              <p>{transcript.deponent}</p>
            </div>

            <div>
              <p className="my-2 font-medium text-gray-700">Objective:</p>
              <p>{transcript.objective}</p>
            </div>

            <div>
              <p className="my-2 font-medium text-gray-700">Other Speakers:</p>
              <div className="-mx-0.5 flex flex-wrap gap-2">
                {transcript.otherSpeakers?.map((speaker) => (
                  <p
                    key={speaker}
                    className="w-fit rounded-md border border-sky-300 bg-sky-50 px-1.75 py-0.5 text-sky-600"
                  >
                    {speaker}
                  </p>
                ))}
              </div>
            </div>

            {transcript.phraseList && transcript.phraseList.length && (
              <div>
                <p className="my-2 font-medium text-gray-700">Phrase List:</p>
                <p className="italic">{transcript.phraseList.join(', ')}</p>
              </div>
            )}

            <div>
              <p className="my-2 flex items-center gap-1.5 font-medium text-gray-700">
                <Icon className="lucide--calendar" />
                <span>Created Date:</span>
              </p>
              <p>
                {new Date(transcript.createdDate).toLocaleString(i18n.language, {
                  dateStyle: 'medium',
                  timeStyle: 'medium',
                })}
              </p>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
